// extracted by mini-css-extract-plugin
export default {"labelWithIconContainer":"LabelWithIcon_labelWithIconContainer__5xg3u","iconWrapper":"LabelWithIcon_iconWrapper__Vxy0P"};